import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import CustomButton from '../../CustomButton';

const ModalNewMapOptions = (props) => {
	const { onHide, renderHomepage, setShowNewMapFeedbackModal, setRenderHomepage } = props;
	const { t } = useTranslation('translation', { keyPrefix: 'components.layout.modalNewMapOptions' });
	const storedMapType = JSON.parse(localStorage.getItem("storedMap"))?.type;
	const [selectedMap, setSelectedMap] = useState(storedMapType);
	const isSaveDisabled = selectedMap === storedMapType;

	const onSaveClick = () => {
		if (selectedMap !== storedMapType) {
			const now = Date.now();
			const updatedData = { start: now, type: selectedMap };
			if (selectedMap === "google") {
				setShowNewMapFeedbackModal(true);
			} else if (selectedMap === "here") {
				updatedData.feedback = false;
			}

			localStorage.setItem("storedMap", JSON.stringify(updatedData));
			setRenderHomepage(!renderHomepage);
		}

		onHide();
	}

	const handleMapSelect = (mapType) => {
		setSelectedMap(mapType);
	}

	return (
		<Modal
			show
			onHide={onHide}
			className="modal-lg-size modal-new-map-options"
		>
			<Modal.Header closeButton>
				<Modal.Title>{t('titleSelectMapStyle')}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="select-wrapper">
					<div className="map-item">
						<img className={selectedMap === 'here' ? 'selected' : ''} onClick={() => handleMapSelect('here')} src="/images/here_map.png" alt="HERE Map" />
						<span>{t('standardMap')}</span>
					</div>
					<div className="map-item">
						<img className={selectedMap === 'google' ? 'selected' : ''} onClick={() => handleMapSelect('google')} src="/images/google_map.png" alt="Google Map" />
						<span>{t('classicMap')}</span>
					</div>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<CustomButton variant="primary-outline" onClick={onHide}>
					{t('btnBack')}
				</CustomButton>
				<CustomButton variant="primary" disabled={isSaveDisabled} prefix={`${isSaveDisabled ? 'custom-disabled' : ''}`} onClick={onSaveClick}>
					{t('btnSave')}
				</CustomButton>
			</Modal.Footer>
		</Modal>
	)
}

ModalNewMapOptions.propTypes = {
	onHide: PropTypes.func.isRequired,
}

const mapStateToProps = ({ dashboardData }) => ({
	showNewMapFeedbackModal: dashboardData.showNewMapFeedbackModal,
	renderHomepage: dashboardData.renderHomepage,
});

const mapDispatchToProps = dispatch => ({
	setShowNewMapFeedbackModal: (state) => {
		dispatch({ type: 'SET_SHOW_NEW_MAP_FEEDBACK_MODAL', payload: state })
	},
	setRenderHomepage: (state) => {
		dispatch({ type: 'SET_RENDER_HOMEPAGE', payload: state })
	},
})

export default connect(mapStateToProps, mapDispatchToProps)(ModalNewMapOptions);
